import { useRootStore } from 'stores/RootStore'
import { useEffect } from 'react'
import { useCurrentWorkspace } from './useCurrentWorkspace'

export const useCreditUsage = () => {
  const creditUsageStore = useRootStore().creditUsageStore
  const workspace = useCurrentWorkspace()

  const { creditUsage, initialized, loading } = creditUsageStore

  useEffect(() => {
    if (!initialized && !loading && workspace) {
      creditUsageStore.fetch(workspace.id)
    }
  }, [initialized, loading, creditUsageStore, workspace])

  return {
    creditUsage,
    initialized,
    loading,
    contentCreditsUsed: creditUsage?.content_credits_used || 0,
    videoCreditsUsed: creditUsage?.video_credits_used || 0,
    adsCreditsUsed: creditUsage?.ads_credits_used || 0,
    totalCreditsAvailable: creditUsage?.total_credits_available || 0,
    totalCreditsUsed: creditUsage?.total_credits_used || 0,
    creditsRemaining: creditUsage?.credits_remaining || 0,
    creditsExceeded: creditUsage?.credits_exceeded || false,
    subscriptionId: creditUsage?.subscription_id,
    startDate: creditUsage?.start_date,
    endDate: creditUsage?.end_date,
    usageCosts: creditUsage?.usage_costs,
    baseCreditsAvailable: creditUsage?.base_credits_available || 0,
  }
}
